import { useIsMobile, mobileBreakpoint, useL10n } from '@uplift/hooks';
import {
  AsyncButton,
  Modal, ModalActions, ModalCancelButton, ModalContent
} from '@uplift/ui-v2';

import { useSettingsStyles } from '../../../../settings/styles';

export type TurnOffAutopayModalProps = {
  onCancel: () => void;
  onSubmit: () => Promise<void>;
};

export const TurnOffAutopayModal: React.FC<TurnOffAutopayModalProps> = ({ onCancel, onSubmit }) => {
  const l10n = useL10n();
  const { classes } = useSettingsStyles();
  const isMobile = useIsMobile(mobileBreakpoint);

  return (
    <Modal
      open
      onClose={onCancel}
      title={l10n.accountSettings.billing.turnOffAutopay}
      fullWidth
      maxWidth="md"
      showCloseIcon={!isMobile}
      classes={{ paperWidthMd: classes.paperWidthMd }}
    >
      <ModalContent>
        {l10n.accountSettings.billing.lateFeesWillContinueToBeCharged}
      </ModalContent>
      <ModalActions className={isMobile ? classes.mobileModalActions : null}>
        <ModalCancelButton variant="text" onClick={onCancel} fullWidth>
          {l10n.general.cancel}
        </ModalCancelButton>
        <AsyncButton variant="contained" color="secondary" onClick={onSubmit} fullWidth>
          {l10n.accountSettings.billing.turnOffAutopay}
        </AsyncButton>
      </ModalActions>
    </Modal>
  );
};
